import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { Machine } from '../materials/machines';

export interface DailyMachine {
    _id: string;
    machineId: Machine;
    activityId: string;
    state: number;
    isUsed: boolean;
    price?: number;
    priceType?: number;
    quantity: number;
    unitPrice?: number;
}

export interface DeleteDailyMachineResponse {
    message: string;
    data: DailyMachine;
}

export interface DeleteDailyMachineQueries {
    deleteTransfers?: boolean;
}

export const deleteDailyMachine = async (id: string, queries?: DeleteDailyMachineQueries): Promise<DeleteDailyMachineResponse> => {
    try {
        const response: AxiosResponse<DeleteDailyMachineResponse> = await apiClient.delete(`/daily-machines/${id}`, { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

interface CreateDailyMachineResponse {
    message: string;
    data: DailyMachine;
}

export const createDailyMachine = async (
    activityId: string,
    machineId: string,
    state: number,
    createTransfer?: boolean,
    price?: number | null,
    priceType?: number | null,
    quantity?: number
): Promise<CreateDailyMachineResponse> => {
    try {
        const response: AxiosResponse<CreateDailyMachineResponse> = await apiClient.post('/daily-machines', {
            activityId,
            machineId,
            state,
            createTransfer,
            price,
            priceType,
            quantity,
        });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface DailyMachineResponse {
    message: string;
    data: DailyMachine;
}

export interface UpdateDailyMachineBody {
    activityId?: string;
    machineId?: string;
    state?: number;
    createTransfer?: boolean;
    isUsed?: boolean;
    price?: number | null;
    priceType?: number | null;
    quantity?: number;
    unitPrice?: number | null;
}

export interface UpdateDailyMachineQueries {
    deleteTransfers?: boolean;
    syncTransfers?: boolean;
}

export const updateDailyMachine = async (
    id: string,
    body: UpdateDailyMachineBody,
    queries?: UpdateDailyMachineQueries
): Promise<DailyMachineResponse> => {
    try {
        const response: AxiosResponse<DailyMachineResponse> = await apiClient.patch('/daily-machines/' + id, body, { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
